module.exports = __webpack_public_path__ + "static/media/movie02.58f11c7a.jpg";